<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_black.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n" @click="navClick(n,i.name)">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import urlObj from "../../static/path";
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "门户首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "门户首页",
          path: "/",
          children: []
        },
        {
          name: "招采平台",
          path: "/boffing",
          children: []
        },
        // {
        //   name: "大宗物资",
        //   path: "/",
        //   children: []
        // },
        {
          name: "电子商城",
          path: "/",
          children: []
        },
        {
          name: "老字号",
          path: "/",
          children: []
        },
        {
          name: "资金信息",
          path: "/",
          children: [
            {
              name:"金融产品",
              path:'/'
            },
            {
              name:"定制需求",
              path:'/'
            },
            {
              name:"走进村集体",
              path:'/NJSHomePage'
            },
          ]
        },
        {
          name: "门户专区",
          //path: "/",
          path: "/portalzone",
          children: []
        },
        {
          name: "入驻供应商",
          path: "/supplierinfo",
          children: []
        },
        // {
        //   name: "政策法规",
        //   path: "",
        //   children: [
        //     {
        //      name:"国家相关政策",
        //      path:'/policieslaw/nationalpolicy'
        //     },
        //     {
        //      name:"地方相关政策",
        //      path:'/policieslaw/localpolicy'
        //     },
        //     {
        //      name:"平台政策",
        //      path:'/policieslaw/platformpolicy'
        //     },
        //   ]
        // }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      debugger
      if(name==="电子商城"){
        window.open(urlObj.dzsc)
      }
      // else if(name==="招采平台"){
      //   window.open(" https://appdev.mochasoft.com.cn/user-center-view/login")
      // }
      else if(name==="老字号"){
        window.open(urlObj.lzh)
      } else if (name === "门户专区") {
        this.navIndex = index;
        this.$router.push({ name: 'portalzone' })
      }else if(name==="金融产品"){
        window.open(urlObj.zjsccgr)
      }else if(name==="定制需求"){
        window.open(urlObj.zjxycgr)
      }
      else {
        this.navIndex = index;
        sessionStorage.setItem('navIndex',index)
        this.menuName = name;
      }
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #ffffff;
  transition: all ease 0.6s;
  width: 1300px;
  margin: auto;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #ffffff;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 50px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 200px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 200px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 50px;
  float: left;
  margin-left: 100px;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  text-decoration: none;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 110px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}</style>



// WEBPACK FOOTER //
// src/components/Header.vue